<template>
  <div class="row">
    <div v-if="!disabled" class="col-md-4 col-sm-12">
      <slot name="selectionInputs"></slot>
      <action-button
        variant="success float-right"
        text="Añadir"
        i="fas fa-file-medical"
        @click="addItem"
      />
    </div>
    <div
      class="col-sm-12 mt-2 mt-md-0"
      :class="{ 'col-md-8 chips-col': !disabled }"
    >
      <label v-if="!disabled" class="field-label" :class="itemsTitleClass">
        {{ selectedItemsTitle }}
      </label>
      <div class="chips-container">
        <div
          class="chip"
          v-for="(chipData, index) in selectedItemsFilter"
          :key="index"
        >
          <template v-for="(config, idx) in chipsConfig">
            <span :key="idx">
              <span
                class="chip-label"
                v-if="config.labelText && chipData[config.valueProp]"
              >
                {{ config.labelText }}
              </span>
              <span class="chip-field font-weight-bold">
                {{ chipData[config.valueProp] }}
              </span>
            </span>
          </template>
          <a v-if="canDelete(chipData)" @click.prevent="removeChip(index)">
            <em class="far fa-lg fa-times-circle chip-close-icon" />
          </a>
        </div>
        <error
          v-if="errors.length > 0"
          variant="no-border"
          :message="errors[0]"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.chip {
  border: 1px solid #b7c4bd;
  border-radius: 16px;
  display: inline-block;
  padding: 2px 4px 2px 14px;
  margin: 0 0.5rem 0.5rem 0.5rem;
}

.chip-label {
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #727272;
  font-weight: normal;
}

.chip-field {
  margin-right: 1rem;
  margin-left: 0.25rem;
}

.chip-close-icon {
  color: red;
  vertical-align: -2px;
}

.chips-col {
  border-left: 1px solid #e2e2e2;
}

@media only screen and (max-width: 768px) {
  .chips-col {
    border-left: unset;
  }
}
</style>

<script>
import ActionButton from '@/components/common/ActionButton';
import Error from '@/components/common/Error';

export default {
  name: 'ChipsSelection',
  meta: {
    description: 'Componente para entrada de selecciones multi-nivel.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    ActionButton,
    Error,
  },
  model: {
    prop: 'selectedItems',
    event: 'selectionChanged',
  },
  props: {
    selectedItemsTitle: {
      type: String,
      default: () => null,
    },
    itemsTitleClass: {
      type: String,
      default: () => null,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    lockedItems: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
      default: () => [],
    },
    chipsConfig: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    filterProp: {
      type: String,
      default: () => null,
    },
  },
  computed: {
    hasError() {
      return this.requiredSelectionCount > 0 &&
        this.selectedItems.length < this.requiredSelectionCount
        ? true
        : false;
    },
    canDelete() {
      return (item) => {
        return this.disabled
          ? false
          : !this.lockedItems.includes(item.roleId?.toUpperCase());
      };
    },
    selectedItemsFilter() {
      if (this.filterProp) {
        return this.selectedItems.filter(
          (c) =>
            Object.prototype.hasOwnProperty.call(c, this.filterProp) &&
            c[this.filterProp]
        );
      }

      return this.selectedItems;
    },
  },
  methods: {
    removeChip(index) {
      let itemToRemove = this.selectedItemsFilter[index];

      let indexToRemove = this.selectedItems.indexOf(itemToRemove);

      let deleted = this.selectedItems.splice(indexToRemove, 1);
      this.$emit('selectionChanged', this.selectedItems);
      this.$emit('removingItem', deleted[0]);
    },
    async addItem() {
      let self = this;
      let preItemCount = this.selectedItems.length;
      let newItem = await this.$listeners.addingItem();

      if (newItem) {
        self.selectedItems.push(newItem);
      }
      if (preItemCount < self.selectedItems.length) {
        self.$emit('selectionChanged', self.selectedItems);
      }
    },
  },
};
</script>
